import { graphql } from 'react-relay/hooks'
import { ConnectionHandler } from 'react-relay'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportRestoreMutation($input: RestoreReportInput!) {
    restoreReport(input: $input) {
      report {
        id
        rowId
        company {
          id
        }
      }
    }
  }
`

const updater = (store, { restoreReport }) => {
  const company = store.get(restoreReport.report.company.id)

  // remove from the reports table connection when filtered
  // to show only archived rows
  const connection = ConnectionHandler.getConnection(company, 'ReportsTable_reports', {
    includeDeleted: 'EXCLUSIVELY',
    orderBy: 'CREATED_AT_DESC',
  })

  if (connection) {
    ConnectionHandler.deleteNode(connection, restoreReport.report.id)
  }
}

export default function useReportRestore() {
  return useMutation(mutation, 'restoreReport', { updater })
}
